import { render, staticRenderFns } from "./ConfirmTabs.vue?vue&type=template&id=79fc4634&scoped=true"
import script from "./ConfirmTabs.vue?vue&type=script&lang=js"
export * from "./ConfirmTabs.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTabs.vue?vue&type=style&index=0&id=79fc4634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc4634",
  null
  
)

export default component.exports